export enum IGroupType {
    GROUP = 'GROUP',
    COMPARISON = 'COMPARISON',
}
